export default __webpack_public_path__ + "static/thumb-approved-tools-5b0a0de05311d246ed9239311165f004.jpg";